import { ButtonBase, InputAdornment, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import ColorPicker from '../../Components/ColorPicker';
import { SquareRounded } from '@mui/icons-material';
import { ColorFieldProps } from '@/@types/attributeFields';

const ColorField: React.FC<ColorFieldProps> = ({
    name,
    value = '',
    onChange,
    placeholder = '',
    ...props
}) => {
    const { resetField, control } = useFormContext();

    const prefix = '#';
    const prasedValue = value.replace(prefix, '');

    useEffect(
        () => resetField(name, { defaultValue: prasedValue }),
        [prasedValue],
    );

    const [anchorEl, setAnchorEl] = useState(null);

    return (
        <Controller
            control={control}
            name={name}
            defaultValue={prasedValue}
            render={({
                field: { onChange: controlerOnChange, value: controlerValue },
            }) => (
                <TextField
                    fullWidth
                    size="small"
                    value={controlerValue}
                    name={name}
                    placeholder={placeholder.replace(prefix, '')}
                    {...props}
                    onChange={e => {
                        controlerOnChange(e);
                        onChange(e, { prefix });
                    }}
                    InputProps={{
                        sx: { pl: 0.5 },
                        startAdornment: (
                            <>
                                <InputAdornment position="start">
                                    <ButtonBase
                                        // aria-controls={
                                        //     open ? 'basic-menu' : undefined
                                        // }
                                        // aria-haspopup="true"
                                        // aria-expanded={open ? 'true' : undefined}
                                        onClick={e =>
                                            setAnchorEl(e.currentTarget)
                                        }
                                        onMouseDown={e => e.preventDefault()}
                                    >
                                        <SquareRounded
                                            sx={{
                                                fontSize: 32,
                                                color: value || '#777',
                                            }}
                                        />
                                    </ButtonBase>
                                </InputAdornment>
                                <InputAdornment position="start">
                                    {prefix}
                                </InputAdornment>
                                <ColorPicker
                                    anchorEl={anchorEl}
                                    onClose={() => setAnchorEl(null)}
                                    value={controlerValue}
                                    onChange={color => {
                                        controlerOnChange({
                                            target: {
                                                value: color.replace(
                                                    prefix,
                                                    '',
                                                ),
                                                name,
                                            },
                                        });
                                        onChange(color);
                                    }}
                                />
                            </>
                        ),
                    }}
                />
            )}
        />
    );
};

export default ColorField;
